import * as CommercialInvoiceService from 'services/commercialInvoice';
import * as types from '../types/commercialInvoice';
import { NotificationManager } from 'react-notifications';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';

export const getAll = (query, body) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADING',
      payload: true,
    });
    let response = await CommercialInvoiceService.getCommercialInvoices({ ...query, ...body });
    dispatch({
      type: types.SET_COMMERCIAL_INVOICES,
      payload: response,
    });
    dispatch({
      type: 'SET_LOADING',
      payload: false,
    });
  };
};

export const create = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_LOADING',
        payload: true,
      });
      await CommercialInvoiceService.createCommercialInvoice(data);
      NotificationManager.success('Commercial Invoice created successfully');
       dispatch({
      type: 'SET_LOADING',
      payload: false,
    });
      return true;
    } catch (error) {
       dispatch({
      type: 'SET_LOADING',
      payload: false,
    });
      NotificationManager.error(error?.response?.data?.message || 'Failed to create commercial invoice');
      return false;
    }
  };
};

export const update = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_LOADING',
        payload: true,
      });
      await CommercialInvoiceService.updateCommercialInvoice(data);
      NotificationManager.success('Commercial Invoice updated successfully');
      dispatch({
        type: 'SET_LOADING',
        payload: false,
      });
      return true;
    } catch (error) {
      dispatch({
        type: 'SET_LOADING',
        payload: false,
      });
      NotificationManager.error(error?.response?.data?.message || 'Failed to update commercial invoice');
      return false;
    }
  };
};

export const deleteData = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_LOADING',
        payload: true,
      });
      await CommercialInvoiceService.deleteCommercialInvoice(data);
      NotificationManager.success('Commercial Invoice deleted successfully');
      dispatch({
        type: 'SET_LOADING',
        payload: false,
      });
      return true;
    } catch (error) {
      dispatch({
        type: 'SET_LOADING',
        payload: false,
      });
      NotificationManager.error(error?.response?.data?.message || 'Failed to delete commercial invoice');
      return false;
    }
  };
};

export const deleteAllData = (data) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: true,
    });
    await CommercialInvoiceService.deleteAllCommercialInvoices(data);
    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: false,
    });
  };
};

export const exportData = (data) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: true,
    });

    const response = await CommercialInvoiceService.exportCommercialInvoices(data);
    const blob = await response;

    const temp_date = dayjs(new Date()).format('DD/MM/YYYY');
    saveAs(blob, `CommercialInvoice-${temp_date}.csv`);

    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: false,
    });
  };
};

export const exportDataItems = (data) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: true,
    });

    const response = await CommercialInvoiceService.exportCommercialInvoicesItems(data);
    const blob = await response;

    const temp_date = dayjs(new Date()).format('DD/MM/YYYY');
    saveAs(blob, `License Invoice-${temp_date}.csv`);

    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: false,
    });
  };
};



export const save = (values, files) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: true,
    });
   let result = await CommercialInvoiceService.createCommercialInvoice(values);
   if (result)
    setTimeout(() => {
      window.location.reload();
    }, 1000);

    dispatch({
      type: 'SET_ACTION_LOADING',
      payload: false,
    });
  };
};
